<template>
  <div v-if="detailCommande"
       class="is-flex pdt-20px columns section-details">
    <div class="corps column is-10">
      <qd-loader :active="isLoading"
                 class="has-background-background is-paddingless">
        <stepper  :steps="tabFilArianeDcf"
                  :last-active-step="getLastActiveStep"
                  :actual-step="1">
        </stepper>
      </qd-loader>
      <qd-message
          v-if="!isSyncRegleWithLignes && modulePresseActive"
          type="is-warning"
          aria-close-label="Close message">
          {{ $t('editionCommande.informations.regleFacturation.erreur') }}
      </qd-message>
      <user-warning-message
        :users="[
          { id: commande.commercialId, msg: 'utilisateur.warning.commercialArchive' },
          { id: commande.assistantId, msg: 'utilisateur.warning.assistantArchive' },
        ]"/>
      <contact-warning-message :contacts="archivedContacts" class="mgt-20px"/>
      <informations-generales :info="detailCommande.generalInfos"
                              :devisCommande="commande"
                              :type="commande.type"/>
      <client-payeur
        :payeurs="detailCommande.payeurs"
        :afficherLienDetail="afficherLienDetail"
        :intervenantsNonPayeurs="detailCommande.intervenants"
        class="mgt-20px"/>
      <app-detail-renouvellement :devisCommande="commande"/>
      <detail-devis-commande :devisCommande="commande"
                             :isPrevisualisation="false"
                             :isEditPrevisu="false"
                  :detailDevisCommande="detailCommande"
                  :payeurSelected="payeurSelected"
                  :afficherLien="afficherLienDetail">
      </detail-devis-commande>
      <div v-if="detailCommande.commentaireInterne" class="mgt-20px">
        <div class="card"
             id="detail-comments">
          <header class="header-card">
            <p>{{ $t('editionClient.generalTitle.comments')}}</p>
          </header>
          <div class="card-content">
            <template>
              <div class="mgb-10px">
                <strong>{{ $t('editionCommande.informations.internCommentary') }}</strong>
              </div>
              <span>{{ detailCommande.commentaireInterne }}</span>
            </template>
          </div>
        </div>
      </div>
      <indexation-commande
        v-if="moduleIndexationCommandeActive && commande.estIndexable"
        :commande="commande"
        :indice="indice"
        class="mgt-20px"
        id="indexation"
      />
      <historique-commande v-if="commande.historique"
                           class="mgt-20px"
                           :historique="commande.historique" :id="commande.id"
                           :etats="constantes.DEVIS_COMMANDE_ETAT"/>
      <div class="card mgt-20px" id="attachments">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes readOnly
                              deletable
                              autoSave
                              :canAddOrDeletePj="afficherLienDetail"
                              :checkPermissions=checkPermissions(permCommandes.maj) />
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="sticky-20px">
        <dots-menu :steps="steps">
        </dots-menu>
        <information-create-update-user :data="commande"></information-create-update-user>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import historiqueCommande from '@/components/general/historique';
import AppDetailRenouvellement from '@/components/devisCommandes/detailDevisCommande/detailRenouvellement';
import DotsMenu from '@/components/general/dotsMenu';
import InformationsGenerales from '@/components/devisCommandes/detailDevisCommande/informationsGenerales';
import ClientPayeur from '@/components/devisCommandes/detailDevisCommande/clientPayeur';
import AppPiecesJointes from '@/components/general/piecesJointes';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import detailDevisCommande from '@/components/devisCommandes/detailDevisCommande/detailEditionDevisCommande';
import stepper from '@/components/devisCommandeFacture/detail/stepper/stepper';
import createFilArianeCommande from '@/services/dcf/detail/filAriane/createFilArianeCommande';
import { REGIE } from '@/configuration/societe/societe';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import contactWarningMessage from '@/components/commun/tiers/contact/contactWarningMessage';
import { DEVIS_COMMANDE_ETAT } from '@/configuration/devisConf';
import MixinParametreInterne from '@/mixins/parametreInterne';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import getArchivedContactsFromIntervenants from '@/services/contact/getArchivedContactsFromIntervenants';
import IndexationCommande from '@/components/bodac/dcf/indexation/indexationCommandeDetail';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const IndiceEtValeur = createNamespacedHelpers('indiceEtValeur');

export default {
  props: {
    commande: {
      type: Object,
      required: true,
    },
    detailCommande: {
      type: Object,
      required: true,
    },
    payeurSelected: {
      type: Object,
      required: true,
    },
    toolTipSignatureInfo: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  mixins: [MixinParametreInterne],
  components: {
    InformationCreateUpdateUser,
    historiqueCommande,
    InformationsGenerales,
    ClientPayeur,
    DotsMenu,
    AppPiecesJointes,
    AppDetailRenouvellement,
    detailDevisCommande,
    stepper,
    userWarningMessage,
    contactWarningMessage,
    IndexationCommande,
  },
  data() {
    return {
      permCommandes: COMMANDES,
      steps: [
        {
          name: this.$i18n.t('detail.generalInfos.title'),
          ref: '#detail-general',
          active: true,
        },
        {
          name: this.$i18n.t('detail.client.label'),
          ref: '#detail-client',
          active: false,
        },
        {
          name: this.$i18n.t('detail.commande.title'),
          ref: '#detail-command',
          active: false,
        },
        {
          name: this.$i18n.t('editionClient.generalTitle.comments'),
          ref: '#detail-comments',
          active: false,
        },
        {
          name: this.$i18n.t('detail.schedule.title'),
          ref: '#detail-schedule',
          active: false,
        },
        {
          name: this.$i18n.t('detail.commande.historique.title'),
          ref: '#historique',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommande.indexation.title'),
          ref: '#indexation',
          active: false,
        },
        {
          name: this.$i18n.t('piecesJointes.attachments'),
          ref: '#attachments',
          active: false,
        },
      ],
      tabFilArianeDcf: [],
      constantes: {
        REGIE,
        DEVIS_COMMANDE_ETAT,
      },
      archivedContacts: [],
      isLoading: false,
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    getLastActiveStep() {
      const tabFilArianceDcfCloneDeep = cloneDeep(this.tabFilArianeDcf);
      tabFilArianceDcfCloneDeep.splice(0, 1);
      const indexFirstStepNotActive = tabFilArianceDcfCloneDeep.findIndex((filAriane) => {
        return !filAriane.isActive;
      });
      return indexFirstStepNotActive;
    },
    afficherLienDetail() {
      return this.checkIfCurrentSociety(this.commande.societeId);
    },
    isSyncRegleWithLignes() {
      if (this.commande.regleFacturationId) {
        return this.commande.lignesCommande.length > 0
          && this.commande.lignesCommande.some(ligne => {
            return ligne.produit
              && (ligne.produit.regleFacturationId === this.commande.regleFacturationId);
          });
      }
      return true;
    },
    moduleIndexationCommandeActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key);
    },
    ...IndiceEtValeur.mapGetters({
      IndicesEtValeurs: 'items',
    }),
    indice() {
      return this.IndicesEtValeurs.find(idv => idv.id === this.commande.indiceReferenceId)?.libelle || '';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...IndiceEtValeur.mapActions({
      actionsLoadIndiceEtValeur: 'loadIndiceEtValeur',
    }),
    loadFilArianne() {
      this.isLoading = true;
      createFilArianeCommande(this.commande, null, this.toolTipSignatureInfo)
        .then((rsltTabAriane) => {
          this.tabFilArianeDcf = rsltTabAriane;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = true;
          throw e;
        });
    },
  },
  async mounted() {
    this.loadFilArianne();
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key,
      ]);
      await this.actionsLoadIndiceEtValeur({
        societeId: this.commande.societeId,
      });
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
    this.archivedContacts = getArchivedContactsFromIntervenants(this.detailCommande.payeurs);
  },
};
</script>
